import { render, staticRenderFns } from "./veStuLiteraryAwardItem.vue?vue&type=template&id=3cfcb8c3&scoped=true"
import script from "./veStuLiteraryAwardItem.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryAwardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfcb8c3",
  null
  
)

export default component.exports